<template>
  <div>
    <v-row class="mb-3" v-if="seguimientoMaritimo">
      <v-col cols="auto">
        <v-btn color="primary" @click="crearAlertas" :loading="creando">
          <v-icon left>mdi-plus-circle</v-icon> Generar Alertas
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn color="success" @click="enviarSeleccionadas" :disabled="selected.length === 0" :loading="enviando">
          <v-icon left>mdi-send</v-icon> Enviar seleccionadas ({{ selected.length }})
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-chip color="orange" text-color="white" small>
        {{ lista.length }} alertas
      </v-chip>
    </v-row>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="lista"
      :items-per-page="-1"
      :loading="loading"
      class="elevation-1 alertas-table"
      :show-select="!!seguimientoMaritimo"
      item-key="ID"
      dense
      fixed-header
      height="calc(100vh - 220px)"
    >
      <template v-slot:item.FINCA_NOMBRE="{ item }">
        <strong>{{ item.FINCA_NOMBRE }}</strong>
      </template>
      <template v-slot:item.FECHA_CREACION="{ item }">
        {{ item.FECHA_CREACION ? item.FECHA_CREACION.substring(0, 19) : '' }}
      </template>
      <template v-slot:item.FECHA_ENVIO="{ item }">
        {{ item.FECHA_ENVIO ? item.FECHA_ENVIO.substring(0, 19) : '-' }}
      </template>
      <template v-slot:item.ESTADO="{ item }">
        <v-chip :color="item.ESTADO === 'ENVIADO' ? 'green' : 'amber'" small dark>
          {{ item.ESTADO }}
        </v-chip>
      </template>
      <template v-slot:item.accion="{ item }">
        <v-btn icon color="blue" small @click="verMensaje(item)" title="Ver mensaje">          
          <v-icon small>mdi-eye</v-icon>
        </v-btn>
        <v-btn v-if="seguimientoMaritimo" icon color="success" small @click="enviarAlerta(item)" title="Enviar" :disabled="item.ESTADO === 'ENVIADO'">
          <v-icon small>mdi-send</v-icon>
        </v-btn>
        <v-btn icon color="blue" small @click="verLog(item)" title="Ver historial">
          <v-icon small>mdi-history</v-icon>
        </v-btn>

      </template>
    </v-data-table>


    <v-dialog v-model="dialogLog" max-width="800">
      <v-card>
        <v-toolbar height="35" color="blue" dark flat>
          <v-icon left class="mt-1">mdi-history</v-icon>
          <span class="mt-1">Historial de envíos</span>
          <v-spacer></v-spacer>
          <v-btn @click="dialogLog = false" icon dark><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pa-3">
          <v-data-table
            :headers="logHeaders"
            :items="logData"
            :items-per-page="-1"
            dense
            class="elevation-1"
          >
            <template v-slot:item.FECHA="{ item }">
              {{ item.FECHA ? item.FECHA.substring(0, 19) : '' }}
            </template>
            <template v-slot:item.MENSAJE="{ item }">
              
              <div style="max-height: 80px; overflow-y: auto; font-size: 10px;" > {{ item.MENSAJE }}</div>
              
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogMensaje" max-width="800">
      <v-card>
        <v-toolbar height="35" color="blue" dark flat>
          <v-icon left class="mt-1">mdi-email</v-icon>
          <span class="mt-1">Mensaje a enviar</span>
          <v-spacer></v-spacer>
          <v-btn @click="dialogMensaje = false" icon dark><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pa-3" style="text-align: left;">
            <v-container v-html="mensajeAlerta" style="text-align: left;" ></v-container>
              
            
          </v-card-text >
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";

export default {
  name: "AlertasContenido",
  props: {
    awb: { type: String, required: true },
  },
  data: () => ({
    lista: [],
    selected: [],
    loading: false,
    creando: false,
    enviando: false,
    dialogLog: false,
    dialogMensaje: false,
    logData: [],
    logHeaders: [
      { text: "Fecha", value: "FECHA" },
      { text: "Usuario", value: "USER_NAME" },
      { text: "Destinatario", value: "DESTINATARIO" },
      { text: "Asunto", value: "ASUNTO" },
     
    ],
    headers: [
      { text: "ID", value: "ID"},
      { text: "Finca", value: "FINCA_NOMBRE" },
      { text: "DAE", value: "DAE" },
      { text: "Destinatarios", value: "DESTINATARIO" },
      { text: "Estado", value: "ESTADO" },
      { text: "Creado", value: "FECHA_CREACION" },
      { text: "Enviado", value: "FECHA_ENVIO" },
      { text: "Acción", value: "accion", sortable: false },
    ],
    mensajeAlerta: '',
  }),
  methods: {
    ...mapMutations("master", ["setUrl"]),
    ...mapActions("master", ["requestApi", "alertNotification"]),

    cargarAlertas() {
      
      this.loading = true;
      this.selected = [];
      this.setUrl("api/alertas");
      this.requestApi({
        method: "GET",
        data: { awb: this.awb },
      })
        .then((res) => {
          this.lista = res.data.lista || [];
        })
        .catch((error) => {
          this.lista = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    crearAlertas() {
      this.creando = true;
      this.setUrl("api/crear-alertas-guia");
      this.requestApi({
        method: "POST",
        data: { awb: this.awb, user_name: this.user?.USER_NAME || "" },
      })
        .then((res) => {
          if (res.data.success) {
            this.$emit("notify", { msg: "Alertas generadas exitosamente" });
            this.cargarAlertas();
          } else {
            this.$store.dispatch("master/alertNotification", { param: { msg: res.data.msg, error: true } });
            //this.$emit("notify", { msg: res.data.msg, error: true });
          }
        })
        .catch(() => {})
        .finally(() => {
          this.creando = false;
        });
    },

    enviarAlerta(item) {
      this.setUrl("api/enviar-alerta");
      this.requestApi({
        method: "POST",
        data: { alerta_id: item.ID, user_name: this.user?.USER_NAME || "" },
      })
        .then((res) => {
          if (res.data.success) {
            
            this.alertNotification({
              param: {
                html: "Alerta enviada",
                timer: 3000,
                toast: true,
                icon: "success",
                title: "Éxito",
              },
          });
            this.cargarAlertas();
          } else {            
            
            this.alertNotification({
              param: {
                html: res.data.msg,
                timer: false,
                toast: false,
                icon: "error",
                title: "Error",
              },
          });
            
          }
        })
        .catch((error) => {
          
        });
    },

    enviarSeleccionadas() {
      if (this.selected.length === 0) return;
      this.enviando = true;
      const ids = this.selected.map((s) => s.ID);
      
      this.setUrl("api/enviar-alertas-lote");
      this.requestApi({
        method: "POST",
        data: { alertas: ids, user_name: this.user?.USER_NAME || "" },
      })
        .then((res) => {
          if (res.data.success) {
            this.alertNotification({
              param: {
                html: `${res.data.enviadas} de ${res.data.total} alertas enviadas`,
                timer: 3000,
                toast: true,
                icon: "success",
                title: "Éxito",
              },
          });
            /*this.$emit("notify", {
              msg: `${res.data.enviadas} de ${res.data.total} alertas enviadas`,
            });*/
            this.cargarAlertas();
          } else {
            this.alertNotification({
              param: {
                html: res.data.msg,
                timer: false,
                toast: false,
                icon: "error",
                title: "Error",
              },
          });
            /*this.$emit("notify", {
              msg: res.data.msg,
              error: true,
            });*/
          }
        })
        .catch(() => {})
        .finally(() => {
          this.enviando = false;
        });
    },

    verLog(item) {
      this.setUrl("api/datos-alerta-log");
      this.requestApi({
        method: "GET",
        data: { alerta_id: item.ID },
      })
        .then((res) => {
          this.logData = res.data.log || [];
          this.dialogLog = true;
        })
        .catch(() => {
          this.logData = [];
          this.dialogLog = true;
        });
    },

    verMensaje(item){
      this.setUrl("api/ver-mensaje-alerta");
      this.requestApi({
        method: "GET",
        data: { alerta_id: item.ID },
      })
        .then((res) => {
          this.mensajeAlerta = res.data.mensaje || '';
          this.dialogMensaje = true;
        })
        .catch(() => {
          this.mensajeAlerta = '';
          this.dialogMensaje = true;
        }); 

    }
  },
  computed: {
    ...mapGetters("access", ["seguimientoMaritimo"]),
    user() {
      return this.$store.state.master.user;
    },
  },
};
</script>

<style>
.alertas-table.v-data-table .v-data-table__td {
  font-size: 11px !important;
  white-space: nowrap;
}
.alertas-table.v-data-table .v-data-table__th {
  font-size: 11px !important;
  white-space: nowrap;
}
.alertas-table .v-data-table__wrapper {
  overflow-x: auto;
}
.alertas-table table {
  min-width: 100%;
}
</style>
